import React from "react";
import { TableCell } from "@/components/ui/table";
import { KPIOverviewTileModel } from "../../types";
import {
  CHANGE_TONE_STYLES,
  STATUS_STYLES,
} from "../../utils/kpiOverviewStatus";

interface KPIOverviewTableCellProps {
  tile: KPIOverviewTileModel;
}

const NO_VALUE = "-";

const KPIOverviewTableCell: React.FC<KPIOverviewTableCellProps> = ({
  tile,
}) => {
  const style = STATUS_STYLES[tile.status];

  return (
    <TableCell
      aria-label={`${tile.name} ${tile.valueLabel ?? "no value"}, ${style.label}`}
      className="whitespace-nowrap px-3 py-2 text-right"
      data-testid="kpi-overview-table-cell"
    >
      <div
        className={`font-mono text-sm font-normal tabular-nums ${style.value}`}
      >
        {tile.valueLabel ?? NO_VALUE}
      </div>
      <div
        className={`h-4 font-mono text-xs tabular-nums ${CHANGE_TONE_STYLES[tile.changeTone]}`}
      >
        {tile.changeLabel}
      </div>
    </TableCell>
  );
};

export default KPIOverviewTableCell;
